/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from 'prop-types';

import ConditionsComponent from "./ConditionsComponent.jsx";
import EntityWrapperSmallLabel from "../EntityWrappers/EntityWrapperSmallLabel.jsx";
import CardsSelect from "../BasicInputs/CardsSelect.jsx";

class CardsSelectFormComponent extends React.Component {

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state !== nextState || this.props !== nextProps

    }

    render() {
        if (!this.props.justInput) {
            return (<EntityWrapperSmallLabel label={this.props.name}>

                    <CardsSelect
                        className={"grow"}
                        width={"100%"}
                        isReadOnly={this.props.isReadOnly}
                        sections={this.props.sections}

                        value={this.props.options.filter(item => item.value === this.props.value)[0]}
                        onChange={event => {
                            this.props.onChange(event?.value, event)
                        }}
                        options={this.props.options}
                    />

                    {this.props.allowConditions &&
                        <div className="pf-c-button pf-m-plain" aria-label="Popover for input">
                            <ConditionsComponent allowConditions={this.props.allowConditions}
                                                 onConditionChange={(data) => this.props.onConditionChange(data)}
                                                 onConditionRemove={() => this.props.onConditionRemove("")}
                                                 condition={this.props.condition}
                                                 standardValuesLooked={false}/></div>


                    }

                </EntityWrapperSmallLabel>
            )
        } else {
            return (<CardsSelect
                className={"SelectFix120PX"}
                isReadOnly={this.props.isReadOnly}
                sections={this.props.sections}

                // Fixes the overlapping error if the elements is in a scroll container
                // menuPosition="fixed"
                autofocus
                openOnFocus
                value={this.props.options.filter(item => item.value === this.props.value)[0]}
                onChange={event => {
                    this.props.onChange(event.value)
                }}
                options={this.props.options}
            />)

        }
    };
}

export default CardsSelectFormComponent;

CardsSelectFormComponent.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    value: PropTypes.string.isRequired,
    justInput: PropTypes.bool,
    isReadOnly: PropTypes.bool,
}

CardsSelectFormComponent.defaultProps = {
    options: [],
    justInput: false,
    isReadOnly: false,
    name: ""

}